<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Áreas de Negócio</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Áreas</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0">Nome</th>
                    <th scope="col" class="border-0">Aplicação</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(area, index) in areas" :key="index">
                    <td></td>
                    <td>{{ area.Code }}</td>
                    <td>{{ area.Name }}</td>
                    <td>{{ area.Application.Name }}</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('Area', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenArea($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('Area', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenArea($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('Area', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeleteArea($event, index)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      areas == undefined ||
                      areas == null ||
                      areas.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormArea"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <ValidationObserver tag="form" ref="AreaValidationForm">
          <!-- Code -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Código</label>
                <d-form-input
                  type="text"
                  v-model="infoArea.Code"
                  :disabled="true"
                />
            </d-col>
          </d-form-row>
          <!-- Name -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  :class="validatedAreaForm | showValidateError(invalid)"
                  v-model="infoArea.Name"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAreaForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <!-- Application -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Aplicação</label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors, invalid }"
              >
                <d-select
                  :class="validatedAreaForm | showValidateError(invalid)"
                  v-model="infoArea.Application.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="app in applications"
                    v-bind:value="app.Code"
                    v-bind:key="app.Code"
                  >
                    {{ app.Name }}
                  </option>
                </d-select>                
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAreaForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveArea()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Código"
            type="text"
            class="form-control"
            v-model="filter.Code"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            placeholder="Nome"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Area', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova área"
      v-on:click="OpenArea($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "areas",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      countFilter: 0,
      modalTitle: "Nova área",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Code: null,
        Name: null,
      },
      idArea: 0,
      pOpened: null,
      areas: [],
      infoArea: {
        Code: null,
        Name: null,
        Application: {
          Code: null,
        },
      },
      isSeeing: false,
      validatedAreaForm: false,
      applications: [],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListArea();
    },
    "pagination.RowsPerPage": function () {
      this.ListArea();
    },
  },
  mounted() {
    this.ListArea();
    this.ListApplication();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListArea();
    },
    OpenArea: function (e, i, view) {
      e.preventDefault();
      this.validatedAreaForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoArea();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idArea = this.areas[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar área";
        this.GetArea();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova área";
        this.ResetInfoArea();
      } else {
        // View
        this.pOpened = i;
        this.idArea = this.areas[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes da área";
        this.GetArea();
      }
      this.$bvModal.show("mFormArea");
    },
    ResetInfoArea: function () {
      this.infoArea = {
        Code: null,
        Name: null,
        Application: {
          Code: null
        },
      };
    },
    SaveArea: function () {
      this.validatedAreaForm = true;

      this.$refs.AreaValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddArea", this.infoArea)
              .then(() => {
                this.$makeToast(
                  "A área foi cadastrada corretamente na base de dados",
                  "success",
                  "Área"
                );
                this.ListArea();
                this.$bvModal.hide("mFormArea");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao criar a área",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateArea", this.infoArea)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Área"
                );
                this.ListArea();
                this.$bvModal.hide("mFormArea");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar a área",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetArea: function () {
      if (this.idArea != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetArea", { id: this.idArea })
          .then((response) => {
            this.infoArea = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar a área",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListArea: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Code": this.filter.Code,
          "Object.Name": this.filter.Name,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListArea", { params: data })
        .then((response) => {
          this.areas = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as áreas",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Code: null,
        Name: null,
      };
      this.ListArea();
    },
    ConfirmDeleteArea: function (e, i) {
      e.preventDefault();
      let deleted = this.areas[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${deleted.Name}?`,
        "Confirmar",
        this.DeleteArea,
        i
      );
    },
    DeleteArea: function (i) {
      let deleted = this.areas[i];
      this.$store
        .dispatch("DeleteArea", { id: deleted.Id })
        .then(() => {
          this.$makeToast(
            `${deleted.Name} foi removido da sua lista de áreas`,
            "success",
            "Área"
          );
          this.ListArea();
          this.$bvModal.hide("mFormArea");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover a área",
            error
          );
        });
    },
    ListApplication: function () {
      this.$store
        .dispatch("ListApplication", { params: {} })
        .then((response) => {
          this.applications = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de aplicações",
            error
          );
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/areas.vue